import ApartmentIcon from '@mui/icons-material/Apartment';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { ToggleButtonGroup, ToggleButton, Typography, Box } from '@mui/material';
import React from 'react';

import { type ResourceType } from './types';

import { BLUE, BLUE2, GREY } from '@/theme/palette';

type ResourceOption = { label: ResourceType; icon: React.ReactElement };

const resourceTypes: ResourceOption[] = [
  { label: 'Human', icon: <PersonOutlineIcon /> },
  { label: 'Equipment', icon: <BuildOutlinedIcon /> },
  { label: 'Material', icon: <Inventory2OutlinedIcon /> },
  { label: 'Subcontractor', icon: <ApartmentIcon /> },
];

interface ResourceTypeSelectorProps {
  resourceType: ResourceType;
  setResourceType: (value: ResourceType) => void;
  disabled?: boolean;
}

const ResourceTypeSelector: React.FC<ResourceTypeSelectorProps> = ({
  resourceType,
  setResourceType,
  disabled = false,
}) => {
  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography component="label" sx={{ display: 'block', mb: 1, fontWeight: 600, fontSize: 12 }}>
        Resource type{' '}
        <Box component="span" sx={{ color: 'error.main' }}>
          *
        </Box>
      </Typography>

      <ToggleButtonGroup
        value={resourceType}
        exclusive
        disabled={disabled}
        onChange={(_, value) => {
          if (value) setResourceType(value);
        }}
        aria-label="Resource type"
        sx={{
          display: 'flex',
          gap: 1.25,
          '& .MuiToggleButtonGroup-grouped': {
            margin: 0,
            border: `1px solid ${GREY}`,
            borderRadius: '8px !important',
            '&:not(:first-of-type)': {
              borderLeft: `1px solid ${GREY}`,
            },
          },
        }}
      >
        {resourceTypes.map((r) => (
          <ToggleButton
            key={r.label}
            value={r.label}
            aria-label={r.label}
            sx={{
              flex: 1,
              height: 54,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.25,
              textTransform: 'none',
              backgroundColor: '#FFFFFF',
              '& svg': { fontSize: 22 },
              '&.Mui-selected': {
                borderColor: `${BLUE} !important`,
                backgroundColor: `${BLUE2} !important`,
                color: BLUE,
                boxShadow: `0 0 0 1px ${BLUE}`,
                '&:hover': {
                  backgroundColor: BLUE2,
                },
              },
            }}
          >
            {r.icon}
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'inherit', lineHeight: 1 }}>{r.label}</Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default ResourceTypeSelector;
